module.exports = __webpack_public_path__ + "static/img/index-2.364fa6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/index-2.jpg
// module id = g71+
// module chunks = 0